
<template>
    <div class="h-fold-open" >
        <el-card bodyClass="wrapper"  shadow="never" style="border: none">
            <!-- 按钮-点击可以折叠 -->
<!--            <el-button v-if="isShowBottomSearch" class="button" :icon="ArrowDown" :class="isOpen ? 'open' : ''"-->
            <el-button v-if="isShowBottomSearch" class="button el-icon-arrow-down"  :class="isOpen ? 'open' : ''"
                       size="default" @click="clickOpenHidden" circle />

            <!-- 表单搜索部分 -->
            <el-form ref="formRef" :model="formData" :inline="inline" class="search-form"
                     :label-width="labelWidth ? labelWidth : '100px'">

                <formItem ref="formItemRef" :searchs="defaultSearchList" :formData="formData" @search="onItemSearch" />

                <!-- 搜索框折叠部分 -->
                <transition name="fade">
                    <div class="openbox-container" v-if="isShowBottomSearch" ref="openBox"
                         :style="{ height: isOpen ? `${openHeight}px` : '0' }">
                        <formItem :searchs="bottomSearchList" :formData="formData" @search="onItemSearch" />
                    </div>
                </transition>
            </el-form>
        </el-card>
    </div>
</template>

<script>
import FormItem from './formItem.vue';
// import { ArrowDown } from '@element-plus/icons-vue'

export default {
    components: {
        FormItem
    },
    props: {
        closeShadow: {
            type: Boolean,
            default: true
        },
        // searchList值可以为数组或对象， 对象模版{top: [], bottom: []}
        searchList: {
            type: [Object, Array],
            default: () => []
        },
        // 初始默认值
        initialValues: {
            type: Object,
            default: () => ({})
        },
        inline: {
            type: Boolean,
            default: false
        },
        labelWidth: {
            type: String,
            default: '100px'
        }
    },
    data() {
        return {
            formRef: null,
            formData: { ...this.initialValues },
            defaultSearchList: [],
            bottomSearchList: [],
            search_list: this.searchList,
            isOpen: false,
            openHeight: 0
        }
    },
    watch: {
        // Watch for changes in searchList prop and initialize search lists
        searchList: function (newVal) {
            this.search_list = newVal;
            this.initSearchList(newVal);
        },
        // Watch for changes in initialValues prop and update formData
        initialValues: function (newVal) {
            this.formData = newVal;
        }
    },
    computed: {
        isShowBottomSearch() {
            return !Array.isArray(this.search_list) && this.search_list.bottom && this.search_list.bottom.length > 0;
        }
    },
    methods: {
        // 初始化表格
        async initSearchList(searchList) {
            if (Array.isArray(this.search_list)) {
                await this.loadSelectOptions();
                this.defaultSearchList = this.search_list;
            } else if (typeof this.search_list === 'object' && this.search_list !== null) {
                await this.loadCascaderOptions();
                this.defaultSearchList = this.search_list.top;
                this.bottomSearchList = this.search_list.bottom;
            }
        },

        async loadSelectOptions() {
            for (const field of this.search_list) {
                if (field.type === 'select' && typeof field.options === 'function') {
                    field.options = await field.options();
                }
            }
        },

        async loadCascaderOptions() {
            for (let key in this.search_list) {
                if (this.search_list.hasOwnProperty(key)) {
                    for (const field of this.search_list[key]) {
                        if (field.type === 'select' && typeof field.options === 'function') {
                            field.options = await field.options();
                        }
                    }
                }
            }
        },

        // 展开折叠
        clickOpenHidden() {

            this.isOpen = !this.isOpen;
            this.$nextTick(() => {
                console.log(this.$refs.openBox.scrollHeight)
                this.openHeight = this.isOpen ? this.$refs.openBox.scrollHeight : 0; // 获取完整的高度
            });
        },

        // 搜索处理
        onItemSearch(state, formData) {
            // state:根据state值，调用不同的事件方法；reset：重置表单、search：搜索、export：导出
            if (state === 'reset') {
                this.$refs.formRef.resetFields();
            }
            if (state === 'outReset') {
                this.$refs.formItemRef.handleClick('reset');
                return;
            }
            this.$emit(state, formData, state);
        },
        childMethod(){
            console.log('childMethod')
        }
    },
    mounted() {
        this.initSearchList(this.searchList);
    }
};
</script>

<style lang="less" scoped>
.h-fold-open {
    position: relative;
    margin-bottom: 20px;

    /deep/ .wrapper {

        padding-top: 20px !important;
        padding-bottom: 0 !important;
    }
}


    .button {
        position: absolute;
        bottom: -15px !important;
        z-index: 999;
        border: none;
        //放到中间
        right: 50%;
        width: 40px;
        color: #4d81ff;
        font-weight: 600;
    }

    .fold-box {
        height: 94px;
    }

    .openbox-container {
        height: 0;
        overflow: hidden;
        transition: height ease .5s; //动画效果
        background: transparent;
        box-sizing: border-box;

        .content {
            margin-top: 16px;
        }
    }

    /deep/.el-form-item--default{
        padding-bottom: 0;
    }


.open {
    transform: rotate(180deg);
}
</style>



// WEBPACK FOOTER //
// src/Hcomponents/HsearchModel/index.vue